export const CategoryList = ['Our Services', 'About Booking', 'Payment', 'Booking changes and Refunds', '表示しない'] as const;
export type Category = (typeof CategoryList)[number];

export interface EnFaqResponse {
  id: string;
  question: string;
  answer: string; // html
  category: Category[];
  showContactUs?: boolean;

  // metadata
  createdAt: string;
  updatedAt: string;
  publishedAt: string;
  revisedAt: string;
}

export type EnFaqViewModel = EnFaqResponse;

export type EnFaqListViewModel = EnFaqViewModel[];

export const createDefaultEnFaqViewModel = (): EnFaqViewModel => ({
  id: '',
  question: '',
  answer: '',
  category: [],
  showContactUs: false,

  // metadata
  createdAt: '',
  updatedAt: '',
  publishedAt: '',
  revisedAt: '',
});
